import '@babel/polyfill'
import Vue from 'vue'
import Vuetify from 'vuetify'
import App from './App.vue'
import store from './store'
import router from './router'
import axios from 'axios'

import Blagajna from './components/Blagajna'
import Loader from './components/Loader'
import AvtBlagajne from './components/AvtBlagajne'
import AvtBlagajna from './components/AvtBlagajna'

Vue.component('blagajne', Blagajna)
Vue.component('my-loader', Loader)
Vue.component('avt-blagajne', AvtBlagajne)
Vue.component('avt-blagajna', AvtBlagajna)

Vue.config.productionTip = false
Vue.use(Vuetify)

import 'vuetify/dist/vuetify.min.css' // Ensure you are using css-loader

// Some middleware to help us ensure the user is authenticated.
router.beforeEach((to, from, next) => {
  if(to.matched.some(record => record.meta.requiresAuth) && (!router.app.$store.state.api_token || router.app.$store.api_token === 'null')) {
    next({
      path: '/login',
      query: { redirect: to.fullPath }
    })
  } else if (to.name == 'login' && router.app.$store.state.api_token) {
    router.push({
      name: 'domov'
    })
  } else {
    next()
  }
})

// Check local storage to handle refreshes
if (window.localStorage) {
  var localUser = window.localStorage.getItem('user') || null
  var localUserID = window.localStorage.getItem('user_id') || null
  var api_token = window.localStorage.getItem('access_token') || null

  /*console.log(localUser)
  console.log(localUserID)
  console.log(api_token)*/

  if ( (localUser && store.state.user !== localUser) && (api_token && store.state.api_token !== api_token) ) {
    store.commit('setUserID', localUserID)
    store.commit('setUser', localUser)
    store.commit('setToken', api_token)
  }
}

new Vue({
  store,
  router,
  render: h => h(App)
}).$mount('#app')
